// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login[data-v-01266098] {\n  height: 100vh;\n}\n.privacy[data-v-01266098] {\n  color: white;\n  font-size: 0.875rem;\n}\n.title[data-v-01266098] {\n  text-transform: uppercase;\n  font-size: 1.75rem;\n  margin-left: 0.5rem;\n}", ""]);
// Exports
module.exports = exports;
